module.exports = __webpack_public_path__ + "img/20201220_2.a26f7dbd.jpg";